<main class="container full-height d-flex flex-column justify-content-center">
  <p class="text-center text-danger">
    <i class="far fa-times-circle fa-4x"></i>
  </p>
  <h3 class="text-center" i18n>Transaction cancelled</h3>
  <div *ngIf="order && !orderCancelled">
    <p class="text-center" i18n>
      The PayPal transaction has been cancelled. What do you want to do?
    </p>
    <p class="text-center">
      <button (click)="onBtCancel($event)" class="btn btn-danger">
        <i class="far fa-times-circle"></i>&nbsp;
        <span i18n>Cancel my order</span>
      </button>
    </p>

    <p class="text-center" *ngIf="order">
      <button (click)="onBtCash($event)" class="btn btn-primary">
        <i class="fas fa-coins"></i>&nbsp;
        <span *ngIf="order.method == 'd'" i18n>Pay in cash at delivery</span>
        <span *ngIf="order.method == 't'" i18n>Pay in cash at pickup</span>
      </button>
    </p>
  </div>
  <div *ngIf="orderCancelled || !order">
    <p class="text-center" i18n>Your order has been cancelled.</p>
    <p class="text-center">
      <button *ngIf="canClose()" (click)="onBtClose($event)" class="btn btn-primary" i18n>Close this window and go back to {{host.name}}</button>
      <button *ngIf="!canClose()" (click)="onBtClose($event)" class="btn btn-primary" i18n>Go back to {{host.name}}</button>
    </p>
  </div>
</main>
